export default __webpack_public_path__ + "static/vbw-gb-og-2735abc24c951e0c14c20decec71d772.jpg";